import district from "./district.component";
import districtUrls from "./district.urls";
import DistrictTransforms from "./district.transforms";

const districtModule = angular
  .module("app.components.district", [])
  .component("districtPage", district)
  .service("DistrictTransforms", DistrictTransforms)
  .config(districtUrls);

export default districtModule;



// WEBPACK FOOTER //
// ./src/pages/district/district.module.js